import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsAddElementsDeleteModal } from '@/learnpaths/components/LearnpathsAddElementsDeleteModal/LearnpathsAddElementsDeleteModal'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(link)/delete/link/$elementId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  return <LearnpathsAddElementsDeleteModal elementType="link" {...params} />
}
